import { useEffect, useState } from "react"
import { Loader } from "@/components/ui/loader"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { getCandidatePersonalData, patchCandidatePersonalData } from "@/api/candidate/candidatePersonalData.jsx"
import { BackButton } from "@/components/ui/BackButton"

export default function PersonalInfoForm() {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        async function load() {
            try {
                const res = await getCandidatePersonalData() // GET /candidate/candidate
                setData(res)
            } catch (err) {
                console.error("Error loading personal info", err)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target
        if (name in data.address) {
            setData((prev) => ({
                ...prev,
                address: {
                    ...prev.address,
                    [name]: value,
                },
            }))
        } else {
            setData((prev) => ({ ...prev, [name]: value }))
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSaving(true)
        try {
            await patchCandidatePersonalData({candidate: data})
            // Optionally show a toast or feedback here
        } catch (err) {
            console.error("Failed to save personal info", err)
        } finally {
            setSaving(false)
        }
    }

    if (loading) return <Loader />

    const { firstName, lastName, knownAs, niNumber, gender, nationality, dob, phoneNumber, address } = data

    return (
        <div className="space-y-6 p-3 bg-brand-25">
            <BackButton to="/profile/candidate" />
            <form onSubmit={handleSubmit} className="grid gap-4">
                <div>
                    <Label>First Name</Label>
                    <Input className={"bg-white"} value={firstName} name="firstName" onChange={handleChange} />
                </div>
                <div>
                    <Label>Last Name</Label>
                    <Input className={"bg-white"} value={lastName} name="lastName" onChange={handleChange} />
                </div>
                <div>
                    <Label>Known As</Label>
                    <Input className={"bg-white"} value={knownAs} name="knownAs" onChange={handleChange} />
                </div>
                <div>
                    <Label>National Insurance Number</Label>
                    <Input className={"bg-white"} value={niNumber} name="niNumber" onChange={handleChange} />
                </div>
                <div>
                    <Label>Gender</Label>
                    <Input className={"bg-white"} value={gender} name="gender" onChange={handleChange} />
                </div>
                <div>
                    <Label>Nationality</Label>
                    <Input className={"bg-white"} value={nationality} name="nationality" onChange={handleChange} />
                </div>
                <div>
                    <Label>Date of Birth</Label>
                    <Input className={"bg-white"} type="date" value={dob} name="dob" onChange={handleChange} />
                </div>
                <div>
                    <Label>Phone Number</Label>
                    <Input className={"bg-white"} value={phoneNumber} name="phoneNumber" onChange={handleChange} />
                </div>
                <div className="pt-4">
                    <h2 className="font-semibold text-lg mb-2">Address</h2>
                    <div className="grid gap-2">
                        <div>
                            <Label>Address Line 1</Label>
                            <Input className={"bg-white"} value={address?.line1 || ""} name="line1" onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Address Line 2</Label>
                            <Input className={"bg-white"} value={address?.line2 || ""} name="line2" onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Address Line 3</Label>
                            <Input className={"bg-white"} value={address?.line3 || ""} name="line3" onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Town</Label>
                            <Input className={"bg-white"} value={address?.town || ""} name="town" onChange={handleChange} />
                        </div>
                        <div>
                            <Label>County</Label>
                            <Input className={"bg-white"} value={address?.county || ""} name="county" onChange={handleChange} />
                        </div>
                        <div>
                            <Label>Postcode</Label>
                            <Input className={"bg-white"} value={address?.postcode || ""} name="postcode" onChange={handleChange} />
                        </div>
                    </div>
                </div>
                <div>
                    <Button type="submit" disabled={saving}>
                        {saving ? "Saving..." : "Save"}
                    </Button>
                </div>
            </form>
        </div>
    )
}
